module.exports = __webpack_public_path__ + "static/media/login.5a3687ef.png";